<template>
  <div class="page-wrapper">
    <table-list
      :columns="columns" :data="dataList" :loading="loading" :total="total" :current="current"
      @change-page="changePage"
    ></table-list>
  </div>

</template>

<script>
  import TableList from "components/TableList/index";
  import {ownerChangeRecordlist} from "../../../../../api/project";
  import {formatDateTime} from "../../../../../utils/format";

  export default {
    name: "ModifyRecord",
    props:{
      projectFid:{
        type:String,
        default:''
      }
    },
    components:{
      TableList
    },
    data(){
      return {
        limit:10,
        page:1,
        total:0,
        current:1,
        loading:false,
        columns: [
          {
            title: "项目名称",
            key: "projectName",
            align: "center"
          },
          {
            title: "原业主名称",
            key: "oldOwnerName",
            align: "center"
          },
          {
            title: "现业主名称",
            key: "newOwnerName",
            align: "center"
          },
          {
            title: "变更时间",
            key: "lastModifyTime",
            align: "center",
            render:(h,params)=>{
              return h('span',{},formatDateTime(params.row['lastModifyTime']))
            }
          },
          {
            title: "变更人",
            key: "lastModifyBy",
            align: "center"
          },
          // {
          //   title: "备注",
          //   key: "remark",
          //   align: "center"
          // },
        ],
        dataList:[]
      }
    },
    watch:{
      projectFid(){
        this.ownerChangeRecordlist()
      }

    },
    methods:{
      formatDateTime:formatDateTime,
      changePage(n){
        this.current=n
        this.page=n
        this.ownerChangeRecordlist()

      },
      ownerChangeRecordlist(){
        if(!this.projectFid){
          return
        }
        var params={
          projectFid:this.projectFid,
          page:this.page,
          limit:this.limit
        }
        ownerChangeRecordlist(params).then(res=>{
          this.dataList=res.data.tOwnerChangeRecordVos
          this.total=res.data.total
        }).catch(error=>{})
      }
    },
    created(){
      this.ownerChangeRecordlist()

    }
  }
</script>

<style scoped>
  .page-wrapper{
    padding-top: 0;
  }

</style>
